import { __awaiter } from "tslib";
import { truthy } from '@avalara/bat-apps-shared/helpers/index';
import { isEmailValid } from '@avalara/bat-apps-shared/lib/form-validation';
import fetch from '../fetch';
import { fetchBillingAccount } from './biztech';
import { validatePhone } from '../../components/helpers/contact-info';
import { getSystemErrorMessaging } from './error';
import { defaultValidationErrors, receiveBillingContactErrors } from '../../store/billing-contact';
import conf from '../../conf';
export const validateBillingContactForm = () => (dispatch, getState) => {
    const { billingContactEditForm } = getState().billingContact;
    const fieldsToValidate = {
        Address1: { isRequired: true },
        City: { isRequired: true },
        Country: { isRequired: true },
        FirstName: { isRequired: true },
        LastName: { isRequired: true },
        PersonalEmail: { isRequired: false },
        PostalCode: { isRequired: true },
        State: { isRequired: true },
        WorkEmail: { isRequired: true },
        WorkPhone: { isRequired: true },
    };
    const errors = Object.keys(fieldsToValidate).reduce((errorsAccumulator, field) => {
        const value = billingContactEditForm[field];
        const { isRequired } = fieldsToValidate[field];
        const newErrors = Object.assign({}, errorsAccumulator);
        if (isRequired && (value === null || value.trim() === '')) {
            newErrors[field] = 'isRequired';
        }
        if ((field === 'PersonalEmail' || field === 'WorkEmail') && truthy(value) && !isEmailValid(value || '')) {
            newErrors[field] = 'isInvalid';
        }
        if (field === 'WorkPhone' && truthy(value) && !validatePhone(value || '')) {
            newErrors[field] = 'isInvalid';
        }
        return newErrors;
    }, Object.assign({}, defaultValidationErrors));
    dispatch(receiveBillingContactErrors(errors));
};
export const createBillingContact = ({ accountId, customerAccountId, billingContactData, }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(dispatch)(`${conf.API_URL}/api/billingContact/a/${accountId}/b/${customerAccountId}/create`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(billingContactData),
        });
        if (!response.ok)
            throw new Error(`${response.message}`);
        yield fetchBillingAccount(accountId);
    }
    catch (error) {
        dispatch(getSystemErrorMessaging({
            errorCode: '',
        }));
    }
});
